import { LibCategories } from "src/utils/consent";
import { loadScript } from "src/utils/scriptLoader";

export function loadBlackCrow() {
  if (typeof Cypress !== "undefined") {
    return Promise.resolve();
  }

  return loadScript(
    "https://init.blackcrow.ai/js/core/noom.js",
    [LibCategories.targetingCookies],
    { enableCORS: false }
  );
}
